import dayjs from 'dayjs';
import { HoroscopeType } from '../types/horoscope';

/**
 * Determines the zodiac sign based on a birth date
 * @param birthDate - Birth date string in any format that dayjs can parse
 * @returns The zodiac sign in English lowercase
 */
export const getZodiacSign = (birthDate: string | undefined): string => {
  if (!birthDate) return '';
  
  const date = dayjs(birthDate);
  const day = date.date();
  const month = date.month() + 1; // dayjs months are 0-indexed
  
  if ((month === 1 && day >= 20) || (month === 2 && day <= 18)) return 'aquarius';
  if ((month === 2 && day >= 19) || (month === 3 && day <= 20)) return 'pisces';
  if ((month === 3 && day >= 21) || (month === 4 && day <= 19)) return 'aries';
  if ((month === 4 && day >= 20) || (month === 5 && day <= 20)) return 'taurus';
  if ((month === 5 && day >= 21) || (month === 6 && day <= 20)) return 'gemini';
  if ((month === 6 && day >= 21) || (month === 7 && day <= 22)) return 'cancer';
  if ((month === 7 && day >= 23) || (month === 8 && day <= 22)) return 'leo';
  if ((month === 8 && day >= 23) || (month === 9 && day <= 22)) return 'virgo';
  if ((month === 9 && day >= 23) || (month === 10 && day <= 22)) return 'libra';
  if ((month === 10 && day >= 23) || (month === 11 && day <= 21)) return 'scorpio';
  if ((month === 11 && day >= 22) || (month === 12 && day <= 21)) return 'sagittarius';
  return 'capricorn'; // Dec 22 - Jan 19
};

/**
 * Hebrew translations for zodiac signs
 */
export const zodiacHebrewNames: Record<string, string> = {
  'aquarius': 'דלי',
  'pisces': 'דגים',
  'aries': 'טלה',
  'taurus': 'שור',
  'gemini': 'תאומים',
  'cancer': 'סרטן',
  'leo': 'אריה',
  'virgo': 'בתולה',
  'libra': 'מאזניים',
  'scorpio': 'עקרב',
  'sagittarius': 'קשת',
  'capricorn': 'גדי'
};

/**
 * Gets the Hebrew name for a zodiac sign
 * @param zodiacSign - The zodiac sign in English
 * @returns The Hebrew name of the zodiac sign
 */
export const getZodiacHebrewName = (zodiacSign: string): string => {
  return zodiacHebrewNames[zodiacSign.toLowerCase()] || '';
}; 

export const getHoroscopeTypeText = (type: HoroscopeType): string => {
    switch (type) {
      case 'daily':
        return 'יומי';
      case 'weekly':
        return 'שבועי';
      case 'monthly':
        return 'חודשי';
      default:
        return '';
    }
  };